export default {
  categoryId: null,
  items: null,
  news: false,
  loading: false,
  onlyStockArticles: false,
  search: false,
  searchCriteria: null
}